export default {"src":"/_next/static/media/cash.9c69d0c5.svg","height":51,"width":51};